import React from 'react';
import { useTranslation } from 'react-i18next';
import { findFacebookPermission } from './facebookPermissions';

interface FacebookPermissionListProps {
    /** Meta permission names, e.g. from `missing_permissions`. */
    permissions: string[];
    className?: string;
}

/** Permission names with their short descriptions (unknown names are shown bare). */
const FacebookPermissionList: React.FC<FacebookPermissionListProps> = ({
    permissions,
    className,
}) => {
    const { t } = useTranslation('crm');

    return (
        <ul className={className ?? 'list-disc space-y-1 ps-5'}>
            {permissions.map(name => {
                const known = findFacebookPermission(name);
                return (
                    <li key={name}>
                        <code className="rounded bg-muted px-1 py-0.5 text-xs text-foreground">
                            {name}
                        </code>
                        {known && (
                            <span className="text-muted-foreground">
                                {' '}
                                {t(known.descriptionKey)}
                            </span>
                        )}
                    </li>
                );
            })}
        </ul>
    );
};

export default FacebookPermissionList;
